<template>
  <div>
    <div class="pa-3">
      <div>
          External Brain Anatomy: Figures 75-88
      </div>
      <div>
          Internal Brain Transverse: Figures 90-100 (Figure 89 with planes)
      </div>
      <div>
          Internal Brain Coronal: Figures 102-108,110-111 (Figure 101 with planes; Figure 109 hippocampus)
      </div>
      <div>
          Spinal Sections: Figures 119-124 (Figure 118 with planes)
      </div>
      <div>
          Blood Supply: Figures 54-58 (arterial); Figure 68-69 (venous)
      </div>
      <div>
          Brainstem Internal: Figures 126,127,129 (medulla); 131,133,134 (pons), 135,137,138 (midbrain)
      </div>

    </div>
    <v-select class="pa-2" outlined label="Select Figure" @change="load()" :items="keys" v-model="selected">

    </v-select>
    <v-card v-if="selected" flat outlined class="mx-3 pa-3" @click="figureName = !figureName">
      <p v-if="!figureName">
        This figure is what view? <span class="grey--text caption" >(Tap/Click)</span>
      </p>
      <p v-if="figureName">
        {{name()}}
      </p>

    </v-card>
    <v-card v-if="selected" class="mx-3 px-3 py-1" @click="answer()">
      <p class="title">
        What is <span class="title blue--text">{{letters[index]}}</span>? <span class="grey--text caption" v-if="!showAnswer">(Tap/Click)</span><span v-if="showAnswer" class="blue--text title">{{answers[index]}}</span>
      </p>
    </v-card>
    <div class="mx-3 my-2">
      <v-btn v-if="selected" @click="prev()">Prev</v-btn>
      <v-btn v-if="selected" @click="next()">Next</v-btn>
    </div>
    <v-switch class="ml-5" v-if="hasAnnotation" label="Show Drawing Below/Next To Image" v-model="showOutlined">Test</v-switch>
    <img v-if="selected && (!showOutlined || !hasAnnotation)" :src="'/neuro/' + selected +'.png'" />
    <v-layout wrap v-if="hasAnnotation && showOutlined && selected">
      <v-flex xs12 md6>
        <img :src="'/neuro/' + selected +'.png'" />
      </v-flex>
      <v-flex xs12 md6>
        <img :src="'/neuro/' + selected +'d.png'" />
      </v-flex>
    </v-layout>


  </div>
</template>
<script>
import AtlasData from './figures.json'
import firebase from 'firebase'
import moment from 'moment'
export default {
  name: 'NeuroAtlas',
  data() {
    return {
      keys: [],
      selected: null,
      index: 0,
      letters: [],
      answers: [],
      showAnswer: false,
      figureName: false,
      showOutlined: true,
    }
  },
  mounted() {
    this.keys = Object.keys(AtlasData)


  },
  computed: {
    hasAnnotation() {
      if (this.selected) {
        if ('annotation' in AtlasData[this.selected]) {
          return true
        }
        else {
          return false
        }

      }
      else {
        return false
      }

    }
  },
  methods: {
    name() {
      return AtlasData[this.selected].desc
    },
    answer() {
      this.showAnswer = true
      this.DBlogActivity()

    },
    load() {

      let raw = AtlasData[this.selected].data.split(',')
      let letters = []
      let answers = []
      raw.forEach(entry => {
        let split = entry.split('.')
        letters.push(split[0])
        answers.push(split[1])
      })
      this.figureName = false
      this.showAnswer = false
      this.index = 0
      this.letters = letters
      this.answers = answers
    },
    prev() {
      if (this.index != 0) {
        this.showAnswer = false
        this.index -= 1
      }
      else {
        this.showAnser = false
        this.index = this.answers.length - 1
      }
    },
    next() {
      console.log(this.index)
      if (this.index < this.answers.length - 1) {
        this.showAnswer = false
        this.index += 1
      }
      else {
        this.showAnser = false
        this.index = 0
      }
    },
    DBlogActivity() {
      //store date as documents by YYYY-MM-DD with hour objects
      let date = moment().format('YYYY-MM-DD')
      let hour = moment().format('HH')
      let log = {}
      let entry = {
        uid: firebase.auth().currentUser.uid,
        deck: 'NeuroAtlas',
        card: this.selected,
        timestamp: new Date()
      }
      log[hour] = firebase.firestore.FieldValue.arrayUnion(entry)
      log['timestamp'] = new Date()
      firebase.firestore().collection('activityLog')
      .doc(date).set(log, {merge:true})
      firebase.firestore().collection('metrics')
      .doc('metrics').update({
        logs: firebase.firestore.FieldValue.increment(1)
      })
    }
  }
}
</script>
<style scoped>
img {
  width: 100%;
  max-width: 800px;
  height: auto;
}

</style>
